import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=b99270a0&scoped=true&lang=pug&"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerificationForm.vue?vue&type=style&index=0&id=b99270a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99270a0",
  null
  
)

export default component.exports